import React from "react";

function Privacy() {
  return (
    <div style={{ padding: "1rem", maxWidth: "800px", margin: "0 auto" }}>
      {/* Main Title (similar to .howto-title styling) */}
      <h1 className="howto-title">Privacy Policy for Anonysis.io</h1>
      
      <p>
        Welcome to Anonysis.io (the “Service” or “we” or “us”). Your privacy is
        important to us. This Privacy Policy outlines the type of information we
        collect from users and visitors of Anonysis.io, how we use, protect, and
        disclose that information, and the choices you have regarding your information.
        By using the Service, you agree to the terms of this Privacy Policy.
      </p>

      <h2>1. Information We Collect</h2>
      <h3>1.1 Personal Information</h3>
      <p>
        We may collect personally identifiable information (“Personal Information”),
        such as your name and email address, only if you voluntarily provide it to
        us (e.g., when subscribing to a newsletter, creating an account, or contacting
        support).
      </p>
      
      <h3>1.2 Usage Data</h3>
      <p>
        We may automatically collect information about how the Service is accessed
        and used (“Usage Data”). This may include information such as your device’s
        IP address, browser type, browser version, operating system, the pages of our
        Service that you visit, the time and date of your visit, the time spent on
        those pages, and other diagnostic data.
      </p>
      
      <h3>1.3 Cookies and Tracking Technologies</h3>
      <p>
        We use cookies and similar tracking technologies to track the activity on
        our Service. Cookies are files with small amounts of data which may include
        an anonymous unique identifier. You can instruct your browser to refuse all
        cookies or to indicate when a cookie is being sent. However, if you do not
        accept cookies, some parts of our Service may not function properly.
      </p>

      <h2>2. How We Use Your Information</h2>
      <p>We use the information we collect for various purposes, including:</p>
      <ul>
        <li>To provide and maintain our Service</li>
        <li>To notify you about changes to our Service or new features</li>
        <li>To allow you to participate in interactive features of our Service, if you choose to do so</li>
        <li>To provide customer support</li>
        <li>To monitor the usage of our Service and gather analytics to improve its performance and functionality</li>
        <li>To detect, prevent, and address technical issues or fraudulent activity</li>
      </ul>

      <h2>3. Disclosure of Your Information</h2>
      <h3>3.1 Service Providers</h3>
      <p>
        We may employ third-party companies and individuals to facilitate our Service
        (“Service Providers”), to provide the Service on our behalf, or to perform
        Service-related activities. These third parties have access to your Personal
        Information only to perform these tasks on our behalf and are obligated not
        to disclose or use it for any other purpose.
      </p>

      <h3>3.2 Legal Requirements</h3>
      <p>
        We may disclose your Personal Information if required to do so by law or in
        response to valid requests by public authorities (e.g., a court or government
        agency).
      </p>

      <h3>3.3 Business Transfers</h3>
      <p>
        If we are involved in a merger, acquisition, or asset sale, your Personal
        Information may be transferred. We will provide notice if your Personal
        Information becomes subject to a different Privacy Policy.
      </p>

      <h2>4. Data Retention</h2>
      <p>
        We will retain your Personal Information only for as long as is necessary
        for the purposes set out in this Privacy Policy. We may also retain and use
        your Personal Information to comply with legal obligations, resolve disputes,
        and enforce our agreements and policies.
      </p>

      <h2>5. Data Security</h2>
      <p>
        We take reasonable measures to protect the security of your information.
        However, no method of transmission over the internet or electronic storage
        is 100% secure. While we strive to use commercially acceptable means to protect
        your Personal Information, we cannot guarantee absolute security.
      </p>

      <h2>6. International Data Transfers</h2>
      <p>
        If you are located outside of the region where our servers are hosted, your
        information may be transferred to — and maintained on — computers located
        outside of your state, province, country, or other governmental jurisdiction,
        where the data protection laws may differ from those of your jurisdiction.
        Your consent to this Privacy Policy, followed by your submission of Personal
        Information, represents your agreement to such transfer.
      </p>

      <h2>7. Children’s Privacy</h2>
      <p>
        Our Service is not directed to anyone under the age of 13 (or 16 in certain
        jurisdictions). We do not knowingly collect or solicit Personal Information
        from children. If you become aware that your child has provided us with Personal
        Information, please contact us and we will take steps to remove such information
        and terminate the child’s account.
      </p>

      <h2>8. Your Rights and Choices</h2>
      <p>
        Depending on your jurisdiction, you may have certain rights regarding your
        Personal Information, such as the right to access, correct, update, or
        request deletion of your data. To exercise these rights, please contact us
        using the information below.
      </p>

      <h2>9. Changes to This Privacy Policy</h2>
      <p>
        We may update our Privacy Policy from time to time. We will notify you of any
        changes by posting the new Privacy Policy on this page and updating the effective
        date at the top. Your continued use of the Service after we post any modifications
        to this Privacy Policy will constitute your acknowledgment of the modifications
        and your consent to abide by the revised Privacy Policy.
      </p>

      <h2>10. Contact Us</h2>
      <p>
        If you have any questions or concerns about this Privacy Policy, please
        contact us at:
      </p>
      <ul>
        <li>Email: <a href="mailto:info@anonysis.io">info@anonysis.io</a></li>
      </ul>
    </div>
  );
}

export default Privacy;
